import request from './axios'
// 在这里放置请求接口数据

// 读取页面数据
export function getPageData(params) {
  return request({
    method: 'GET',
    url: '/common/page/pc',
    params: params,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 登录
export function goLogin(data) {
  return request({
    method: 'POST',
    url: '/user/login/phone',
    data,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 微信登录
export function doWxLogin(data) {
  return request({
    method: 'POST',
    url: '/user/login/wechat',
    data,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 微信授权
export function wxOauth(data) {
  return request({
    method: 'POST',
    url: '/wechat/oauth/pc',
    data,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取登录验证码
export function getYzm(data) {
  return request({
    method: 'POST',
    url: '/sms/code/login',
    data,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取手机验证码
export function getPhoneYzm(data) {
  return request({
    method: 'POST',
    url: '/sms/code/bind',
    data: { phone: data },
  }).catch((e) => {
    return Promise.reject(e)
  })
}
// 读取用户信息
export function getUserInfo() {
  return request({
    method: 'GET',
    url: '/user/info',
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 我的课程列表
export function getSubjectList(params) {
  return request({
    method: 'GET',
    url: '/user/course',
    params: params,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 我的课表
export function getCourseByDate(start, end) {
  return request({
    method: 'GET',
    url: '/user/course/bydate',
    params: { date: start + ',' + end },
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取订单列表数据
export function getOrderList(data) {
  return request({
    method: 'GET',
    url: '/user/order',
    params: data,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取用户服务数据
export function getServiceList(data) {
  return request({
    method: 'GET',
    url: '/user/service',
    params: data,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取用户优惠券数据
export function getDiscountList(data) {
  return request({
    method: 'GET',
    url: '',
    data,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 读取用户信息数据
export function getUserList() {
  return request({
    method: 'GET',
    url: '/user/info',
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取省市区列表
export function getCityList() {
  return request({
    method: 'GET',
    url: '/common/regions',
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取职业选项
export function getJobList() {
  return request({
    method: 'GET',
    url: '/common/professions',
  }).catch((e) => {
    return Promise.reject(e)
  })
}

export function getCountryList() {
  return request({
    method: 'GET',
    url: '/common/countries',
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 读取推荐文章列表
export function getRecomArticleList(params) {
  return request({
    method: 'GET',
    url: '/common/article/recommendArticleList',
    params: params,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 读取推荐文章列表
export function getArticleDetails(params) {
  return request({
    method: 'GET',
    url: '/common/article/articleDetails',
    params: params,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 更新用户信息
export function setUserInfo(data) {
  return request({
    method: 'POST',
    url: '/user/info/set',
    data,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取订单详情
export function getOrderDetails(data) {
  return request({
    method: 'GET',
    url: '/user/order/details',
    params: { order_sn: data },
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取分类下课程列表
export function getCateCourses(params) {
  return request({
    method: 'GET',
    url: '/course/listByCate',
    params,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 相关课程列表 - 猜你喜欢
export function getLikeCourses(params) {
  return request({
    method: 'GET',
    url: '/course/like',
    params,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取课程详情
export function getSubjectDetails(course_id, masuLogin) {
  return request({
    method: 'GET',
    url: '/course/details',
    params: { course_id, must_login: masuLogin ? 1 : 0 },
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取课程详情
export function getSubjectOutline(hasSection, courseId) {
  if (hasSection) {
    return request({
      method: 'GET',
      url: '/course/sections',
      params: { course_id: courseId },
    }).catch((e) => {
      return Promise.reject(e)
    })
  } else {
    return request({
      method: 'GET',
      url: '/course/chapters',
      params: { course_id: courseId },
    }).catch((e) => {
      return Promise.reject(e)
    })
  }
}

// 更新头像
export function postUserHead(data) {
  const forms = new FormData()
  forms.append('file', data)
  return request({
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'POST',
    url: '/user/info/head',
    data: forms,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 换绑手机号
export function changePhone(data) {
  return request({
    method: 'POST',
    url: '/user/info/rephone',
    data,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 微信绑定/取消绑定
export function changeWechat(wechatToken) {
  return request({
    method: 'POST',
    url: '/user/info/wechat',
    data: { wechatToken: wechatToken },
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 微信绑定/取消绑定
export function changePassword(password) {
  return request({
    method: 'POST',
    url: '/user/info/repass',
    data: { password: password },
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取优惠券
export function getDiscountCouponList(data) {
  return request({
    method: 'GET',
    url: '/user/coupon',
    params: data,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 获取小节信息
export function getSectionInformation(data) {
  return request({
    method: 'GET',
    url: '/course/chapter',
    params: { chapter_id: data },
  }).catch((e) => {
    return Promise.reject(e)
  })
}
// 获取课程资料列表
export function getSubjectData(data) {
  return request({
    method: 'GET',
    url: '/course/attachs',
    params: { course_id: data },
  }).catch((e) => {
    return Promise.reject(e)
  })
}
// 获取课程资料信息
export function getSubjectInfo(params) {
  return request({
    method: 'GET',
    url: '/course/attach',
    params: params,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// 保存学习记录
export function postStudyLearn(data) {
  return request({
    method: 'POST',
    url: '/user/learn/set',
    data,
  }).catch((e) => {
    return Promise.reject(e)
  })
}

// export function getHomeData(data) {
//   return request({
//     method: 'POST',
//     url: '/app/page',
//     data
//   }).catch((e) => { return Promise.reject(e) })
// }
